<template>
  <div class="users">

      <div class="columns is-mobile" style="margin-bottom: -20px;">
        <div class="column">
          <h1 class="title is-4">Users</h1>
        </div>
        <div class="column has-text-right">
          <div class="right">
            <button class="button margin-left margin-bottom" @click="showActive = !showActive">Show {{ showActive ? 'Disabled' : 'Active' }} Users</button>
            <button class="button is-success margin-left margin-bottom" @click="$router.push({path:'/admin/new-user'})">Add User</button>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column" v-if="sortedUsers && sortedUsers.length">
          <table class="table is-hoverable is-striped is-bordered is-clickable">
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user of sortedUsers" :key="user.username" @click="showUser(user)">
                <th><b-tag v-if="!user.active" type="is-danger" class="margin-right">DISABLED</b-tag>{{ user.firstName }} {{ user.lastName }}</th>
                <td>{{ user.username }}</td>
                <td>{{ user.phone }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="column">
          <b-message>THERE ARE NO {{ showActive ? 'ACTIVE' : 'DISABLED' }}</b-message>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'Users',
  data () {
    return {
      users: [],
      showActive: true
    }
  },
  computed: {
    sortedUsers () {
      if (!this.users) return this.users
      const arr = this.users.filter(u => u.active === this.showActive)
      return arr.sort((a, b) => {
        let aStr = a.firstName.trim().toLocaleLowerCase()
        let bStr = b.firstName.trim().toLocaleLowerCase()
        let result = aStr.localeCompare(bStr)
        if (result === 0) {
          aStr = a.lastName.trim().toLocaleLowerCase()
          bStr = b.lastName.trim().toLocaleLowerCase()
          result = aStr.localeCompare(bStr)
        }
        return result
      })
    }
  },
  created () {
    this.fetchUsers()
  },
  methods: {
    fetchUsers () {
      this.unsub('users')
      this.users = null
      this.subs.users = this.$firestore.collection('users')
        .onSnapshot(snapshot => {
          this.users = this.$utils.snapshotToArr(snapshot)
        })
    },
    showUser (user) {
      this.$router.push({ path: `/admin/user/${user.uid}` })
    }
  }
}
</script>
